import Vue from 'vue'

// Inspectors
Vue.component('auditable-inspectors', require('./Inspectors/Index'));

// Auditable Items
Vue.component('testing-history', require('./TestingHistory').default);
Vue.component('testing-history-overview', require('./TestingHistoryOverview').default);
Vue.component('auditable-status', require('./Status').default);
Vue.component('auditable-project', require('./Project').default);
// Vue.component('auditable-trigger-field', require('./TriggerField').default);
Vue.component('auditable-people', require('./People').default);
Vue.component('auditable-set-employer', require('./SetEmployer').default);

// // Field Audits
Vue.component('field-audit', require('./FieldAudits/Show'));
Vue.component('field-audit-inspectors', require('./FieldAudits/Inspectors').default);
Vue.component('field-audit-form', require('./FieldAudits/Form').default);
Vue.component('field-audit-create', require('./FieldAudits/Create').default);
Vue.component('field-audit-update', require('./FieldAudits/Update').default);

// Field Inspection Checklist Process
// Vue.component('field-inspection-checklist', require('./Checklist/FieldAudit').default);

// Field Audits Checkilist
Vue.component('fa-notification-item', require('./FieldAudits/CheckList/Notification').default);
Vue.component('fa-payment-item', require('./FieldAudits/CheckList/Payment').default);
Vue.component('fa-scheduled-item', require('./FieldAudits/CheckList/Schedule').default);
Vue.component('fa-review-item', require('./FieldAudits/CheckList/Review').default);
Vue.component('fa-status-item', require('./FieldAudits/CheckList/Status').default);

// Field Audits Modals
Vue.component('field-audit-status-modal', require('./FieldAudits/CheckList/Modals/Status').default);
Vue.component('field-audit-payment-modal', require('./FieldAudits/CheckList/Modals/Payment').default);
Vue.component('field-audit-schedule-modal', require('./FieldAudits/CheckList/Modals/Schedule').default);
Vue.component('field-audit-notification-modal', require('./FieldAudits/CheckList/Modals/Notification').default);
Vue.component('field-audit-transfer-modal', require('./FieldAudits/CheckList/Modals/Transfer').default);

// Desk Audits
Vue.component('desk-audit', require('./DeskAudits/Show'));
Vue.component('desk-audit-create', require('./DeskAudits/Create').default);
Vue.component('desk-audit-form', require('./DeskAudits/Form').default);
Vue.component('desk-audit-delete', require('./DeskAudits/Delete').default);

// Desk Audits Checkilist
Vue.component('da-notification-item', require('./DeskAudits/CheckList/Notification').default);
Vue.component('da-payment-item', require('./DeskAudits/CheckList/Payment').default);
Vue.component('da-review-item', require('./DeskAudits/CheckList/Review').default);
Vue.component('da-status-item', require('./DeskAudits/CheckList/Status').default);

// Desk Audits Modals
Vue.component('desk-audit-status-modal', require('./DeskAudits/CheckList/Modals/Status').default);
Vue.component('desk-audit-payment-modal', require('./DeskAudits/CheckList/Modals/Payment').default);
Vue.component('desk-audit-notification-modal', require('./DeskAudits/CheckList/Modals/Notification').default);


// // Field Inspections
Vue.component('field-inspection', require('./FieldInspections/Show'));
Vue.component('field-inspection-form', require('./FieldInspections/Form').default);
Vue.component('field-inspection-create', require('./FieldInspections/Create').default);


// Field Inspection Checkilist
Vue.component('fi-notification-item', require('./FieldInspections/CheckList/Notification').default);
Vue.component('fi-payment-item', require('./FieldInspections/CheckList/Payment').default);
Vue.component('fi-scheduled-item', require('./FieldInspections/CheckList/Schedule').default);
Vue.component('fi-review-item', require('./FieldInspections/CheckList/Review').default);
Vue.component('fi-status-item', require('./FieldInspections/CheckList/Status').default);

// Field notification Modals
Vue.component('field-inspection-status-modal', require('./FieldInspections/CheckList/Modals/Status').default);
Vue.component('field-inspection-payment-modal', require('./FieldInspections/CheckList/Modals/Payment').default);
Vue.component('field-inspection-schedule-modal', require('./FieldInspections/CheckList/Modals/Schedule').default);
Vue.component('field-inspection-notification-modal', require('./FieldInspections/CheckList/Modals/Notification').default);

// Algolia DeskAudits Search
Vue.component('desk-audits-actives', require('./DeskAudits/Actives').default);
Vue.component('desk-audits-upcomming', require('./DeskAudits/Upcomming').default);

// Algolia FieldAudits Search
Vue.component('field-audits-actives', require('./FieldAudits/Actives').default);
Vue.component('field-audits-upcomming', require('./FieldAudits/Upcomming').default);

// Algolia FieldInspections Search
Vue.component('field-inspections-actives', require('./FieldInspections/Actives').default);
// Vue.component('field-inspections-upcomming', require('./FieldInspections/Upcomming').default);

// Candidate Projects
Vue.component('candidate-projects', require('./CandidateProjects/Index'));
